"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5934],{

/***/ 95934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dn": function() { return /* reexport safe */ _features_blog_layout__WEBPACK_IMPORTED_MODULE_0__.Dn; },
/* harmony export */   "GZ": function() { return /* reexport safe */ _features_blog_layout__WEBPACK_IMPORTED_MODULE_0__.GZ; },
/* harmony export */   "IV": function() { return /* reexport safe */ _features_blog_layout__WEBPACK_IMPORTED_MODULE_0__.IV; },
/* harmony export */   "zX": function() { return /* reexport safe */ _features_blog_layout__WEBPACK_IMPORTED_MODULE_0__.zX; }
/* harmony export */ });
/* harmony import */ var _features_blog_layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39520);




/***/ }),

/***/ 39520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dn": function() { return /* binding */ EmagazineLayout; },
/* harmony export */   "GZ": function() { return /* binding */ EmagazineMobileLayout; },
/* harmony export */   "IV": function() { return /* binding */ PromotionsLayout; },
/* harmony export */   "T0": function() { return /* binding */ JewelryLayout; },
/* harmony export */   "zX": function() { return /* binding */ PromotionsMobileLayout; }
/* harmony export */ });
/* unused harmony export JewelryMobileLayout */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_ui_Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58262);
/* harmony import */ var _components_ui_MetaTag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42031);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83554);
/* harmony import */ var _home_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27590);
/* harmony import */ var _libs_dayjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74865);
/* harmony import */ var _layouts_shared__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7806);
/* harmony import */ var _contexts_profile__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48309);
// import { LoadingSpin32 } from '@/components/icons/LoadingSpin';
// import ArticleLoop from '@/components/ui/ArticleLoop';





// import { useFetchNewsQuery } from '@/pages/api/home';






var PromotionsLayout = function(param) {
    var blog = param.blog;
    var id = blog.id, yoast_head_json = blog.yoast_head_json;
    var masterData = (0,_contexts_profile__WEBPACK_IMPORTED_MODULE_8__/* .useMasterData */ .AE)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(), articles = ref[0], setArticles = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        page: 1,
        total_page: Math.ceil(blog.count / 5)
    }), pagination = ref1[0], setPagination = ref1[1];
    var ref2 = (0,_home_api__WEBPACK_IMPORTED_MODULE_5__/* .useFetchNewsQuery */ .jR)({
        page: (pagination === null || pagination === void 0 ? void 0 : pagination.page) || 1,
        per_page: 5,
        categories: id
    }, {
        enabled: false,
        refetchOnWindowFocus: false,
        onSuccess: function(data) {
            setArticles(data.data);
            if (data.pagination) setPagination(data.pagination);
        }
    }), refetchArticle = ref2.refetch, isLoading = ref2.isLoading;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        refetchArticle();
    }, [
        refetchArticle,
        id,
        pagination
    ]);
    var onPageChange = function(page) {
        window.scrollTo(0, 0);
        setPagination(function(prev) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, prev), {
                page: page
            });
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_MetaTag__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: blog.name,
                image: "".concat("https://anthu.vn", "/logo-bg.png")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "tw-hidden",
                children: yoast_head_json.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "tw-hidden",
                children: yoast_head_json.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "tw-hidden",
                children: yoast_head_json.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container tw-pb-10 tw-pt-5 md:tw-pt-10 md:tw-border-t tw-border-primary-main tw-text-secondary-70",
                children: [
                    (masterData === null || masterData === void 0 ? void 0 : masterData.menu_blogs) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-overflow-x-scroll md:tw-hidden",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "tw-flex tw-items-center tw-gap-x-8 tw-text-lg md:tw-text-xl tw-uppercase tw-mb-5 tw-overflow-x-scroll tw-w-max",
                            children: masterData === null || masterData === void 0 ? void 0 : masterData.menu_blogs.map(function(m) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                                    className: "".concat(blog.slug === m.slug ? "tw-font-semibold tw-border-b-[3px] tw-border-primary-main" : "", " !tw-text-secondary-70"),
                                    url: {
                                        pathname: _layouts_shared__WEBPACK_IMPORTED_MODULE_7__/* .PagePath.BlogPage */ ._.BlogPage,
                                        query: {
                                            id: m.slug
                                        }
                                    },
                                    children: m.name
                                }, m.name);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "Tin tức"
                            }),
                            " > ",
                            blog.name
                        ]
                    }),
                    isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-flex tw-justify-center tw-mt-6",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_Icon__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .J, {
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .LoadingSpin32 */ .JT, {}),
                            className: "tw-w-8 tw-h-8 tw-text-primary-main"
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "tw-mt-4 lg:tw-mt-6 ",
                            children: !!articles && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "tw-pt-6 tw-flex tw-flex-col tw-gap-y-5 md:tw-pt-10",
                                    children: [
                                        articles === null || articles === void 0 ? void 0 : articles.map(function(article) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "tw-w-full tw-h-max",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "tw-w-full tw-relative tw-h-[460px] md:tw-h-[370px] lg:tw-h-[420px] 2xl:tw-h-[460px]",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "tw-w-full tw-relative tw-pb-[75%] md:tw-pb-[35%] lg:tw-pb-[26%]",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .Ee, {
                                                                src: article.thumbnail_url || "",
                                                                alt: article.title.rendered,
                                                                className: "!tw-absolute tw-w-full tw-h-full tw-left-0 tw-top-0",
                                                                objectFit: "cover"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "tw-w-11/12 md:tw-w-[600px] tw-rounded-t-[28px] tw-px-4 md:tw-px-8 lg:tw-px-10 tw-py-4 lg:tw-py-8 tw-bg-white tw-absolute tw-left-1/2 tw--translate-x-1/2 tw-top-[80%] md:tw-top-[65%] tw-text-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "tw-text-center",
                                                                        children: (0,_libs_dayjs__WEBPACK_IMPORTED_MODULE_6__/* .humanTimeArticle */ .KM)(article.modified, "")
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                                        className: "tw-mt-3 tw-text-lg md:tw-text-xl lg:tw-text-2xl tw-leading-8 tw-font-semibold tw-text-center tw-line-clamp-2",
                                                                        dangerouslySetInnerHTML: {
                                                                            __html: article.title.rendered
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                                        className: "tw-mt-2 tw-line-clamp-2 tw-text-base tw-italic",
                                                                        dangerouslySetInnerHTML: {
                                                                            __html: article.yoast_head_json.description || ""
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                                                                        url: {
                                                                            pathname: _layouts_shared__WEBPACK_IMPORTED_MODULE_7__/* .PagePath.ArticlePage */ ._.ArticlePage,
                                                                            query: {
                                                                                id: article.slug
                                                                            }
                                                                        },
                                                                        className: "!tw-underline tw-inline-block tw-mt-1",
                                                                        children: [
                                                                            "Xem th\xeam ",
                                                                            ">"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            }, "article-" + article.id);
                                        }),
                                        pagination && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "tw-flex tw-mt-5 tw-justify-end",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Pagination */ .tl, {
                                                page: pagination.page || 0,
                                                count: (pagination === null || pagination === void 0 ? void 0 : pagination.total_page) || 0,
                                                onPageChange: onPageChange
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var PromotionsMobileLayout = function(param) {
    var blog = param.blog;
    var id = blog.id, yoast_head_json = blog.yoast_head_json;
    var masterData = (0,_contexts_profile__WEBPACK_IMPORTED_MODULE_8__/* .useMasterData */ .AE)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(), articles = ref[0], setArticles = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        page: 1,
        total_page: Math.ceil(blog.count / 5)
    }), pagination = ref1[0], setPagination = ref1[1];
    var ref2 = (0,_home_api__WEBPACK_IMPORTED_MODULE_5__/* .useFetchNewsQuery */ .jR)({
        page: (pagination === null || pagination === void 0 ? void 0 : pagination.page) || 1,
        per_page: 5,
        categories: id
    }, {
        enabled: false,
        refetchOnWindowFocus: false,
        onSuccess: function(data) {
            setArticles(data.data);
            if (data.pagination) setPagination(data.pagination);
        }
    }), refetchArticle = ref2.refetch, isLoading = ref2.isLoading;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        refetchArticle();
    }, [
        refetchArticle,
        id,
        pagination
    ]);
    var onPageChange = function(page) {
        window.scrollTo(0, 0);
        setPagination(function(prev) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, prev), {
                page: page
            });
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_MetaTag__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: blog.name,
                image: "".concat("https://anthu.vn", "/logo-bg.png")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "tw-hidden",
                children: yoast_head_json.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "tw-hidden",
                children: yoast_head_json.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "tw-hidden",
                children: yoast_head_json.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container tw-pb-10 tw-pt-5 md:tw-pt-10 md:tw-border-t tw-border-primary-main tw-text-secondary-70",
                children: [
                    (masterData === null || masterData === void 0 ? void 0 : masterData.menu_blogs) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-overflow-x-scroll md:tw-hidden",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "tw-flex tw-items-center tw-gap-x-8 tw-text-lg md:tw-text-xl tw-uppercase tw-mb-5  tw-overflow-x-scroll tw-w-max",
                            children: masterData === null || masterData === void 0 ? void 0 : masterData.menu_blogs.map(function(m) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                                    className: "".concat(blog.slug === m.slug ? "tw-font-semibold tw-border-b-[3px] tw-border-primary-main" : "", " !tw-text-secondary-70"),
                                    url: {
                                        pathname: _layouts_shared__WEBPACK_IMPORTED_MODULE_7__/* .PagePath.BlogMobilePage */ ._.BlogMobilePage,
                                        query: {
                                            id: m.slug
                                        }
                                    },
                                    children: m.name
                                }, m.name);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "Tin tức"
                            }),
                            " > ",
                            blog.name
                        ]
                    }),
                    isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-flex tw-justify-center tw-mt-6",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_Icon__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .J, {
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .LoadingSpin32 */ .JT, {}),
                            className: "tw-w-8 tw-h-8 tw-text-primary-main"
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "tw-mt-4 lg:tw-mt-6 ",
                            children: !!articles && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "tw-pt-6 tw-flex tw-flex-col tw-gap-y-5 md:tw-pt-10",
                                    children: [
                                        articles === null || articles === void 0 ? void 0 : articles.map(function(article) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "tw-w-full tw-h-max",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "tw-w-full tw-relative tw-h-[460px] md:tw-h-[370px] lg:tw-h-[420px] 2xl:tw-h-[460px]",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "tw-w-full tw-relative tw-pb-[75%] md:tw-pb-[35%] lg:tw-pb-[26%]",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .Ee, {
                                                                src: article.thumbnail_url || "",
                                                                alt: article.title.rendered,
                                                                className: "!tw-absolute tw-w-full tw-h-full tw-left-0 tw-top-0",
                                                                objectFit: "cover"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "tw-w-11/12 md:tw-w-[600px] tw-rounded-t-[28px] tw-px-4 md:tw-px-8 lg:tw-px-10 tw-py-4 lg:tw-py-8 tw-bg-white tw-absolute tw-left-1/2 tw--translate-x-1/2 tw-top-[80%] md:tw-top-[65%] tw-text-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "tw-text-center",
                                                                        children: (0,_libs_dayjs__WEBPACK_IMPORTED_MODULE_6__/* .humanTimeArticle */ .KM)(article.modified, "")
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                                        className: "tw-mt-3 tw-text-lg md:tw-text-xl lg:tw-text-2xl tw-leading-8 tw-font-semibold tw-text-center tw-line-clamp-2",
                                                                        dangerouslySetInnerHTML: {
                                                                            __html: article.title.rendered
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                                        className: "tw-mt-2 tw-line-clamp-2 tw-text-base tw-italic",
                                                                        dangerouslySetInnerHTML: {
                                                                            __html: article.yoast_head_json.description || ""
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                                                                        url: {
                                                                            pathname: _layouts_shared__WEBPACK_IMPORTED_MODULE_7__/* .PagePath.ArticleMobilePage */ ._.ArticleMobilePage,
                                                                            query: {
                                                                                id: article.slug
                                                                            }
                                                                        },
                                                                        className: "!tw-underline tw-inline-block tw-mt-1",
                                                                        children: [
                                                                            "Xem th\xeam ",
                                                                            ">"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            }, "article-" + article.id);
                                        }),
                                        pagination && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "tw-flex tw-mt-5 tw-justify-end",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Pagination */ .tl, {
                                                page: pagination.page || 0,
                                                count: (pagination === null || pagination === void 0 ? void 0 : pagination.total_page) || 0,
                                                onPageChange: onPageChange
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var EmagazineLayout = function(param) {
    var blog = param.blog;
    var masterData = (0,_contexts_profile__WEBPACK_IMPORTED_MODULE_8__/* .useMasterData */ .AE)();
    var id = blog.id, yoast_head_json = blog.yoast_head_json;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(), articles = ref[0], setArticles = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(), firstArticle = ref1[0], setFirstArticle = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        page: 1,
        total_page: Math.ceil(blog.count / 8)
    }), pagination = ref2[0], setPagination = ref2[1];
    var ref3 = (0,_home_api__WEBPACK_IMPORTED_MODULE_5__/* .useFetchNewsQuery */ .jR)({
        offset: ((pagination.page || 1) - 1) * 8 + 1,
        per_page: 8,
        categories: id
    }, {
        enabled: false,
        refetchOnWindowFocus: false,
        onSuccess: function(data) {
            setArticles(data.data);
        }
    }), refetchArticle = ref3.refetch, isLoading = ref3.isLoading;
    var ref4 = (0,_home_api__WEBPACK_IMPORTED_MODULE_5__/* .useFetchNewsQuery */ .jR)({
        page: 1,
        per_page: 1,
        categories: id
    }, {
        enabled: false,
        refetchOnWindowFocus: false,
        onSuccess: function(data) {
            setFirstArticle(data.data[0]);
        }
    }), refetchNewArticle = ref4.refetch;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        refetchArticle();
    }, [
        refetchArticle,
        id,
        pagination
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        refetchNewArticle();
    }, [
        refetchNewArticle,
        id
    ]);
    var onPageChange = function(page) {
        window.scrollTo(0, 0);
        setPagination(function(prev) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, prev), {
                page: page
            });
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_MetaTag__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: blog.name,
                image: "".concat("https://anthu.vn", "/logo-bg.png")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "tw-hidden",
                children: yoast_head_json.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "tw-hidden",
                children: yoast_head_json.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "tw-hidden",
                children: yoast_head_json.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container tw-pt-5 md:tw-pt-10 md:tw-border-t tw-border-primary-main tw-text-secondary-70",
                children: [
                    (masterData === null || masterData === void 0 ? void 0 : masterData.menu_blogs) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-overflow-x-scroll md:tw-hidden",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "tw-flex tw-items-center tw-gap-x-8 tw-text-lg md:tw-text-xl tw-uppercase tw-mb-5  tw-overflow-x-scroll tw-w-max",
                            children: masterData === null || masterData === void 0 ? void 0 : masterData.menu_blogs.map(function(m) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                                    className: "".concat(blog.slug === m.slug ? "tw-font-semibold tw-border-b-[3px] tw-border-primary-main" : "", " !tw-text-secondary-70"),
                                    url: {
                                        pathname: _layouts_shared__WEBPACK_IMPORTED_MODULE_7__/* .PagePath.BlogPage */ ._.BlogPage,
                                        query: {
                                            id: m.slug
                                        }
                                    },
                                    children: m.name
                                }, m.name);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "Tin tức"
                            }),
                            " > ",
                            blog.name
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "tw-flex tw-justify-center tw-mt-6",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_Icon__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .J, {
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .LoadingSpin32 */ .JT, {}),
                        className: "tw-w-8 tw-h-8 tw-text-primary-main"
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "tw-mt-4 lg:tw-mt-6 ",
                            children: firstArticle && pagination.page == 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "tw-w-full tw-h-max",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "tw-w-full tw-relative tw-h-[460px] xs:tw-h-[640px] md:tw-h-[460px] lg:tw-h-[480px] xl:tw-h-[560px] 2xl:tw-h-[640px] 3xl:tw-h-auto 3xl:tw-mb-[96px]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "tw-w-full tw-relative tw-pb-[75%] md:tw-pb-[35%] lg:tw-pb-[30%]",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .Ee, {
                                                src: firstArticle.thumbnail_url || "",
                                                alt: firstArticle.title.rendered,
                                                className: "!tw-absolute tw-w-full tw-h-full tw-left-0 tw-top-0",
                                                objectFit: "cover"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "tw-w-11/12 md:tw-w-[600px] tw-rounded-t-[28px] tw-px-4 md:tw-px-8 lg:tw-px-10 tw-py-4 lg:tw-py-8 tw-bg-white tw-absolute tw-left-1/2 tw--translate-x-1/2 tw-top-[80%] tw-text-center",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "tw-text-center",
                                                        children: (0,_libs_dayjs__WEBPACK_IMPORTED_MODULE_6__/* .humanTimeArticle */ .KM)(firstArticle.modified, "")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                        className: "tw-mt-3 tw-text-lg md:tw-text-xl lg:tw-text-2xl tw-leading-8 tw-font-semibold tw-text-center tw-line-clamp-2",
                                                        dangerouslySetInnerHTML: {
                                                            __html: firstArticle.title.rendered
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                        className: "tw-mt-2 tw-line-clamp-2 tw-text-base tw-italic",
                                                        dangerouslySetInnerHTML: {
                                                            __html: firstArticle.yoast_head_json.description || ""
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                                                        url: {
                                                            pathname: _layouts_shared__WEBPACK_IMPORTED_MODULE_7__/* .PagePath.ArticlePage */ ._.ArticlePage,
                                                            query: {
                                                                id: firstArticle.slug
                                                            }
                                                        },
                                                        className: "!tw-underline tw-inline-block tw-mt-1",
                                                        children: [
                                                            "Xem th\xeam ",
                                                            ">"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }, "first-article")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container tw-pb-10",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    !!articles && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "tw-mt-6 tw-grid md:tw-grid-cols-2 tw-gap-4 md:tw-gap-6 lg:tw-gap-10 md:tw-mt-10",
                                            children: articles === null || articles === void 0 ? void 0 : articles.map(function(article) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "tw-w-full tw-h-max",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "tw-w-full tw-relative tw-h-[460px] sm:tw-h-[600px] md:tw-h-[400px] lg:tw-h-[520px] 2xl:tw-h-[570px]",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "tw-w-full tw-relative tw-pb-[75%] md:tw-pb-[72%]",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .Ee, {
                                                                    src: article.thumbnail_url || "",
                                                                    alt: article.title.rendered,
                                                                    className: "!tw-absolute tw-w-full tw-h-full tw-left-0 tw-top-0",
                                                                    objectFit: "cover"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "tw-w-11/12 md:tw-w-5/6 tw-rounded-t-[28px] tw-p-4 lg:tw-p-6 tw-bg-white tw-absolute tw-left-1/2 tw--translate-x-1/2 tw-top-[80%] tw-text-center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: "tw-text-center",
                                                                            children: (0,_libs_dayjs__WEBPACK_IMPORTED_MODULE_6__/* .humanTimeArticle */ .KM)(article.modified, "")
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                                            className: "tw-mt-3 tw-text-lg md:tw-text-xl lg:tw-text-2xl tw-leading-8 tw-font-semibold tw-text-center tw-line-clamp-2",
                                                                            dangerouslySetInnerHTML: {
                                                                                __html: article.title.rendered
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                                            className: "tw-mt-2 tw-line-clamp-2 tw-text-sm lg:tw-text-base tw-italic ",
                                                                            dangerouslySetInnerHTML: {
                                                                                __html: article.yoast_head_json.description || ""
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                                                                            url: {
                                                                                pathname: _layouts_shared__WEBPACK_IMPORTED_MODULE_7__/* .PagePath.ArticlePage */ ._.ArticlePage,
                                                                                query: {
                                                                                    id: article.slug
                                                                                }
                                                                            },
                                                                            className: "!tw-underline tw-inline-block tw-mt-1",
                                                                            children: [
                                                                                "Xem th\xeam ",
                                                                                ">"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }, "article-" + article.id);
                                            })
                                        })
                                    }),
                                    pagination && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "tw-flex tw-mt-5 tw-justify-end",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Pagination */ .tl, {
                                            page: pagination.page || 0,
                                            count: (pagination === null || pagination === void 0 ? void 0 : pagination.total_page) || 0,
                                            onPageChange: onPageChange
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var EmagazineMobileLayout = function(param) {
    var blog = param.blog;
    var masterData = (0,_contexts_profile__WEBPACK_IMPORTED_MODULE_8__/* .useMasterData */ .AE)();
    var id = blog.id, yoast_head_json = blog.yoast_head_json;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(), articles = ref[0], setArticles = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(), firstArticle = ref1[0], setFirstArticle = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        page: 1,
        total_page: Math.ceil(blog.count / 8)
    }), pagination = ref2[0], setPagination = ref2[1];
    var ref3 = (0,_home_api__WEBPACK_IMPORTED_MODULE_5__/* .useFetchNewsQuery */ .jR)({
        offset: ((pagination.page || 1) - 1) * 8 + 1,
        per_page: 8,
        categories: id
    }, {
        enabled: false,
        refetchOnWindowFocus: false,
        onSuccess: function(data) {
            setArticles(data.data);
        }
    }), refetchArticle = ref3.refetch, isLoading = ref3.isLoading;
    var ref4 = (0,_home_api__WEBPACK_IMPORTED_MODULE_5__/* .useFetchNewsQuery */ .jR)({
        page: 1,
        per_page: 1,
        categories: id
    }, {
        enabled: false,
        refetchOnWindowFocus: false,
        onSuccess: function(data) {
            setFirstArticle(data.data[0]);
        }
    }), refetchNewArticle = ref4.refetch;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        refetchArticle();
    }, [
        refetchArticle,
        id,
        pagination
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        refetchNewArticle();
    }, [
        refetchNewArticle,
        id
    ]);
    var onPageChange = function(page) {
        window.scrollTo(0, 0);
        setPagination(function(prev) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, prev), {
                page: page
            });
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_MetaTag__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: blog.name,
                image: "".concat("https://anthu.vn", "/logo-bg.png")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "tw-hidden",
                children: yoast_head_json.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "tw-hidden",
                children: yoast_head_json.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "tw-hidden",
                children: yoast_head_json.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container tw-pb-10 tw-pt-5 md:tw-pt-10 md:tw-border-t tw-border-primary-main tw-text-secondary-70",
                children: [
                    (masterData === null || masterData === void 0 ? void 0 : masterData.menu_blogs) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-overflow-x-auto md:tw-hidden",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "tw-flex tw-items-center tw-gap-x-8 tw-text-lg md:tw-text-xl tw-uppercase tw-mb-5 tw-overflow-x-scroll tw-w-max",
                            children: masterData === null || masterData === void 0 ? void 0 : masterData.menu_blogs.map(function(m) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                                    className: "".concat(blog.slug === m.slug ? "tw-font-semibold tw-border-b-[3px] tw-border-primary-main" : "", " !tw-text-secondary-70"),
                                    url: {
                                        pathname: _layouts_shared__WEBPACK_IMPORTED_MODULE_7__/* .PagePath.BlogMobilePage */ ._.BlogMobilePage,
                                        query: {
                                            id: m.slug
                                        }
                                    },
                                    children: m.name
                                }, m.name);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "Tin tức"
                            }),
                            " > ",
                            blog.name
                        ]
                    }),
                    isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-flex tw-justify-center tw-mt-6",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_Icon__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .J, {
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .LoadingSpin32 */ .JT, {}),
                            className: "tw-w-8 tw-h-8 tw-text-primary-main"
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "tw-mt-4 lg:tw-mt-6 ",
                                children: [
                                    firstArticle && pagination.page == 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "tw-w-full tw-h-max",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "tw-w-full tw-relative tw-h-[460px] md:tw-h-[320px] lg:tw-h-[420px] 2xl:tw-h-[460px]",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "tw-w-full tw-relative tw-pb-[75%] md:tw-pb-[35%] lg:tw-pb-[26%]",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .Ee, {
                                                        src: firstArticle.thumbnail_url || "",
                                                        alt: firstArticle.title.rendered,
                                                        className: "!tw-absolute tw-w-full tw-h-full tw-left-0 tw-top-0",
                                                        objectFit: "cover"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "tw-w-11/12 md:tw-w-[600px] tw-rounded-t-[28px] tw-px-4 md:tw-px-8 lg:tw-px-10 tw-py-4 lg:tw-py-8 tw-bg-white tw-absolute tw-left-1/2 tw--translate-x-1/2 tw-top-[80%] md:tw-top-[65%] tw-text-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "tw-text-center",
                                                                children: (0,_libs_dayjs__WEBPACK_IMPORTED_MODULE_6__/* .humanTimeArticle */ .KM)(firstArticle.modified, "")
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                                className: "tw-mt-3 tw-text-lg md:tw-text-xl lg:tw-text-2xl tw-leading-8 tw-font-semibold tw-text-center tw-line-clamp-2",
                                                                dangerouslySetInnerHTML: {
                                                                    __html: firstArticle.title.rendered
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                                className: "tw-mt-2 tw-line-clamp-2 tw-text-base tw-italic",
                                                                dangerouslySetInnerHTML: {
                                                                    __html: firstArticle.yoast_head_json.description || ""
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                                                                url: {
                                                                    pathname: _layouts_shared__WEBPACK_IMPORTED_MODULE_7__/* .PagePath.ArticleMobilePage */ ._.ArticleMobilePage,
                                                                    query: {
                                                                        id: firstArticle.slug
                                                                    }
                                                                },
                                                                className: "!tw-underline tw-inline-block tw-mt-1",
                                                                children: [
                                                                    "Xem th\xeam ",
                                                                    ">"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }, "first-article"),
                                    !!articles && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "tw-mt-6 tw-grid md:tw-grid-cols-2 tw-gap-4 md:tw-gap-6 lg:tw-gap-10 md:tw-mt-10",
                                            children: articles === null || articles === void 0 ? void 0 : articles.map(function(article) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "tw-w-full tw-h-max",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "tw-w-full tw-relative tw-h-[460px] md:tw-h-[400px] lg:tw-h-[520px] 2xl:tw-h-[570px]",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "tw-w-full tw-relative tw-pb-[75%] md:tw-pb-[72%]",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .Ee, {
                                                                    src: article.thumbnail_url || "",
                                                                    alt: article.title.rendered,
                                                                    className: "!tw-absolute tw-w-full tw-h-full tw-left-0 tw-top-0",
                                                                    objectFit: "cover"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "tw-w-11/12 md:tw-w-5/6 tw-rounded-t-[28px] tw-p-4 lg:tw-p-6 tw-bg-white tw-absolute tw-left-1/2 tw--translate-x-1/2 tw-top-[80%] tw-text-center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: "tw-text-center",
                                                                            children: (0,_libs_dayjs__WEBPACK_IMPORTED_MODULE_6__/* .humanTimeArticle */ .KM)(article.modified, "")
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                                            className: "tw-mt-3 tw-text-lg md:tw-text-xl lg:tw-text-2xl tw-leading-8 tw-font-semibold tw-text-center tw-line-clamp-2",
                                                                            dangerouslySetInnerHTML: {
                                                                                __html: article.title.rendered
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                                            className: "tw-mt-2 tw-line-clamp-2 tw-text-sm lg:tw-text-base tw-italic ",
                                                                            dangerouslySetInnerHTML: {
                                                                                __html: article.yoast_head_json.description || ""
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                                                                            url: {
                                                                                pathname: _layouts_shared__WEBPACK_IMPORTED_MODULE_7__/* .PagePath.ArticleMobilePage */ ._.ArticleMobilePage,
                                                                                query: {
                                                                                    id: article.slug
                                                                                }
                                                                            },
                                                                            className: "!tw-underline tw-inline-block tw-mt-1",
                                                                            children: [
                                                                                "Xem th\xeam ",
                                                                                ">"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }, "article-" + article.id);
                                            })
                                        })
                                    })
                                ]
                            }),
                            pagination && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "tw-flex tw-mt-5 tw-justify-end",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Pagination */ .tl, {
                                    page: pagination.page || 0,
                                    count: (pagination === null || pagination === void 0 ? void 0 : pagination.total_page) || 0,
                                    onPageChange: onPageChange
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var JewelryLayout = function(param) {
    var blog = param.blog;
    var masterData = (0,_contexts_profile__WEBPACK_IMPORTED_MODULE_8__/* .useMasterData */ .AE)();
    var id = blog.id, yoast_head_json = blog.yoast_head_json;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(), articles = ref[0], setArticles = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(), firstArticle = ref1[0], setFirstArticle = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        page: 1,
        total_page: Math.ceil(blog.count / 8)
    }), pagination = ref2[0], setPagination = ref2[1];
    var ref3 = (0,_home_api__WEBPACK_IMPORTED_MODULE_5__/* .useFetchNewsQuery */ .jR)({
        offset: ((pagination.page || 1) - 1) * 8 + 1,
        per_page: 9,
        categories: id
    }, {
        enabled: false,
        refetchOnWindowFocus: false,
        onSuccess: function(data) {
            setArticles(data.data);
        }
    }), refetchArticle = ref3.refetch, isLoading = ref3.isLoading;
    var ref4 = (0,_home_api__WEBPACK_IMPORTED_MODULE_5__/* .useFetchNewsQuery */ .jR)({
        page: 1,
        per_page: 1,
        categories: id
    }, {
        enabled: false,
        refetchOnWindowFocus: false,
        onSuccess: function(data) {
            setFirstArticle(data.data[0]);
        }
    }), refetchNewArticle = ref4.refetch;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        refetchArticle();
    }, [
        refetchArticle,
        id,
        pagination
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        refetchNewArticle();
    }, [
        refetchNewArticle,
        id
    ]);
    var onPageChange = function(page) {
        window.scrollTo(0, 0);
        setPagination(function(prev) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, prev), {
                page: page
            });
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_MetaTag__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: blog.name,
                image: "".concat("https://anthu.vn", "/logo-bg.png")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "tw-hidden",
                children: yoast_head_json.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "tw-hidden",
                children: yoast_head_json.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "tw-hidden",
                children: yoast_head_json.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container tw-pb-10 tw-pt-5 md:tw-pt-10 md:tw-border-t tw-border-primary-main tw-text-secondary-70",
                children: [
                    (masterData === null || masterData === void 0 ? void 0 : masterData.menu_blogs) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-overflow-x-scroll",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "tw-flex tw-items-center tw-gap-x-8 tw-text-lg md:tw-text-xl tw-uppercase tw-mb-5 md:tw-hidden tw-w-max",
                            children: masterData === null || masterData === void 0 ? void 0 : masterData.menu_blogs.map(function(m) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                                    className: "".concat(blog.slug === m.slug ? "tw-font-semibold tw-border-b-[3px] tw-border-primary-main" : "", " !tw-text-secondary-70"),
                                    url: {
                                        pathname: _layouts_shared__WEBPACK_IMPORTED_MODULE_7__/* .PagePath.BlogPage */ ._.BlogPage,
                                        query: {
                                            id: m.slug
                                        }
                                    },
                                    children: m.name
                                }, m.name);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "Tin tức"
                            }),
                            " > ",
                            blog.name
                        ]
                    }),
                    isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-flex tw-justify-center tw-mt-6",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_Icon__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .J, {
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .LoadingSpin32 */ .JT, {}),
                            className: "tw-w-8 tw-h-8 tw-text-primary-main"
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "tw-mt-4 lg:tw-mt-6 ",
                                children: [
                                    firstArticle && pagination.page == 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "tw-w-full tw-h-max",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "tw-w-full tw-relative tw-h-[460px] md:tw-h-[360px] lg:tw-h-[420px] 2xl:tw-h-[460px]",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "tw-w-full tw-relative tw-pb-[75%] md:tw-pb-[35%] lg:tw-pb-[26%]",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .Ee, {
                                                        src: firstArticle.thumbnail_url || "",
                                                        alt: firstArticle.title.rendered,
                                                        className: "!tw-absolute tw-w-full tw-h-full tw-left-0 tw-top-0",
                                                        objectFit: "cover"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "tw-w-11/12 md:tw-w-[600px] tw-rounded-t-[28px] tw-px-4 md:tw-px-8 lg:tw-px-10 tw-py-4 lg:tw-py-8 tw-bg-white tw-absolute tw-left-1/2 tw--translate-x-1/2 tw-top-[80%] md:tw-top-[65%] tw-text-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "tw-text-center",
                                                                children: (0,_libs_dayjs__WEBPACK_IMPORTED_MODULE_6__/* .humanTimeArticle */ .KM)(firstArticle.modified, "")
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                                className: "tw-mt-3 tw-text-lg md:tw-text-xl lg:tw-text-2xl tw-leading-8 tw-font-semibold tw-text-center tw-line-clamp-2",
                                                                dangerouslySetInnerHTML: {
                                                                    __html: firstArticle.title.rendered
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                                className: "tw-mt-2 tw-line-clamp-2 tw-text-base tw-italic",
                                                                dangerouslySetInnerHTML: {
                                                                    __html: firstArticle.yoast_head_json.description || ""
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                                                                url: {
                                                                    pathname: _layouts_shared__WEBPACK_IMPORTED_MODULE_7__/* .PagePath.ArticlePage */ ._.ArticlePage,
                                                                    query: {
                                                                        id: firstArticle.slug
                                                                    }
                                                                },
                                                                className: "!tw-underline tw-inline-block tw-mt-1",
                                                                children: [
                                                                    "Xem th\xeam ",
                                                                    ">"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }, "first-article"),
                                    !!articles && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "tw-mt-6 tw-grid md:tw-grid-cols-2 xl:tw-grid-cols-3 tw-gap-4 md:tw-gap-5 md:tw-mt-10",
                                            children: articles === null || articles === void 0 ? void 0 : articles.map(function(article) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "tw-w-full tw-h-max",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "tw-w-full tw-relative tw-h-[460px] md:tw-h-[350px] lg:tw-h-[360px] 2xl:tw-h-[400px]",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "tw-w-full tw-relative tw-pb-[75%] md:tw-pb-[72%]",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .Ee, {
                                                                    src: article.thumbnail_url || "",
                                                                    alt: article.title.rendered,
                                                                    className: "!tw-absolute tw-w-full tw-h-full tw-left-0 tw-top-0",
                                                                    objectFit: "cover"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "tw-w-11/12 md:tw-w-5/6 tw-rounded-t-[28px] tw-p-4 lg:tw-p-4 tw-bg-white tw-absolute tw-left-1/2 tw--translate-x-1/2 tw-top-[80%] tw-text-center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: "tw-text-center tw-text-sm",
                                                                            children: (0,_libs_dayjs__WEBPACK_IMPORTED_MODULE_6__/* .humanTimeArticle */ .KM)(article.modified, "")
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                                                                            url: {
                                                                                pathname: _layouts_shared__WEBPACK_IMPORTED_MODULE_7__/* .PagePath.ArticlePage */ ._.ArticlePage,
                                                                                query: {
                                                                                    id: article.slug
                                                                                }
                                                                            },
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                                                className: "tw-mt-2 tw-text-base md:tw-text-lg tw-leading-4 tw-font-semibold tw-text-center tw-line-clamp-2 md:tw-leading-[22px] tw-uppercase tw-text-secondary-70",
                                                                                dangerouslySetInnerHTML: {
                                                                                    __html: article.title.rendered
                                                                                }
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                                            className: "tw-mt-1 tw-line-clamp-2 tw-text-sm lg:tw-text-base tw-italic ",
                                                                            dangerouslySetInnerHTML: {
                                                                                __html: article.yoast_head_json.description || ""
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }, "article-" + article.id);
                                            })
                                        })
                                    })
                                ]
                            }),
                            pagination && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "tw-flex tw-mt-5 tw-justify-end",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Pagination */ .tl, {
                                    page: pagination.page || 0,
                                    count: (pagination === null || pagination === void 0 ? void 0 : pagination.total_page) || 0,
                                    onPageChange: onPageChange
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var JewelryMobileLayout = function(param) {
    var blog = param.blog;
    var id = blog.id, yoast_head_json = blog.yoast_head_json;
    var masterData = useMasterData();
    var ref = useState(), articles = ref[0], setArticles = ref[1];
    var ref1 = useState({
        page: 1,
        total_page: Math.ceil(blog.count / 5)
    }), pagination = ref1[0], setPagination = ref1[1];
    var ref2 = useFetchNewsQuery({
        page: (pagination === null || pagination === void 0 ? void 0 : pagination.page) || 1,
        per_page: 5,
        categories: id
    }, {
        enabled: false,
        refetchOnWindowFocus: false,
        onSuccess: function(data) {
            setArticles(data.data);
            if (data.pagination) setPagination(data.pagination);
        }
    }), refetchArticle = ref2.refetch, isLoading = ref2.isLoading;
    useEffect(function() {
        refetchArticle();
    }, [
        refetchArticle,
        id,
        pagination
    ]);
    var onPageChange = function(page) {
        window.scrollTo(0, 0);
        setPagination(function(prev) {
            return _object_spread_props(_object_spread({}, prev), {
                page: page
            });
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(MetaTag, {
                title: blog.name,
                image: "".concat("https://anthu.vn", "/logo-bg.png")
            }),
            /*#__PURE__*/ _jsx("h1", {
                className: "tw-hidden",
                children: yoast_head_json.title
            }),
            /*#__PURE__*/ _jsx("h2", {
                className: "tw-hidden",
                children: yoast_head_json.title
            }),
            /*#__PURE__*/ _jsx("h2", {
                className: "tw-hidden",
                children: yoast_head_json.title
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "container tw-pb-10 tw-pt-5 md:tw-pt-10 md:tw-border-t tw-border-primary-main tw-text-secondary-70",
                children: [
                    (masterData === null || masterData === void 0 ? void 0 : masterData.menu_blogs) && /*#__PURE__*/ _jsx("div", {
                        className: "tw-overflow-x-scroll md:tw-hidden",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "tw-flex tw-items-center tw-gap-x-8 tw-text-lg md:tw-text-xl tw-uppercase tw-mb-5 tw-overflow-x-scroll tw-w-max",
                            children: masterData === null || masterData === void 0 ? void 0 : masterData.menu_blogs.map(function(m) {
                                return /*#__PURE__*/ _jsx(Link, {
                                    className: "".concat(blog.slug === m.slug ? "tw-font-semibold tw-border-b-[3px] tw-border-primary-main" : "", " !tw-text-secondary-70"),
                                    url: {
                                        pathname: PagePath.BlogMobilePage,
                                        query: {
                                            id: m.slug
                                        }
                                    },
                                    children: m.name
                                }, m.name);
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                children: "Tin tức"
                            }),
                            " > ",
                            blog.name
                        ]
                    }),
                    isLoading ? /*#__PURE__*/ _jsx("div", {
                        className: "tw-flex tw-justify-center tw-mt-6",
                        children: /*#__PURE__*/ _jsx(Icon, {
                            icon: /*#__PURE__*/ _jsx(LoadingSpin32, {}),
                            className: "tw-w-8 tw-h-8 tw-text-primary-main"
                        })
                    }) : /*#__PURE__*/ _jsx(_Fragment, {
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "tw-mt-4 lg:tw-mt-6 ",
                            children: !!articles && /*#__PURE__*/ _jsx(_Fragment, {
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "tw-pt-6 tw-flex tw-flex-col tw-gap-y-5 md:tw-pt-10",
                                    children: [
                                        articles === null || articles === void 0 ? void 0 : articles.map(function(article) {
                                            return /*#__PURE__*/ _jsx("div", {
                                                className: "tw-w-full tw-h-max",
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    className: "tw-w-full tw-relative tw-h-[460px] md:tw-h-[370px] lg:tw-h-[420px] 2xl:tw-h-[460px]",
                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                        className: "tw-w-full tw-relative tw-pb-[75%] md:tw-pb-[35%] lg:tw-pb-[26%]",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Image, {
                                                                src: article.thumbnail_url || "",
                                                                alt: article.title.rendered,
                                                                className: "!tw-absolute tw-w-full tw-h-full tw-left-0 tw-top-0",
                                                                objectFit: "cover"
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "tw-w-11/12 md:tw-w-[600px] tw-rounded-t-[28px] tw-px-4 md:tw-px-8 lg:tw-px-10 tw-py-4 lg:tw-py-8 tw-bg-white tw-absolute tw-left-1/2 tw--translate-x-1/2 tw-top-[80%] md:tw-top-[65%] tw-text-center",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "tw-text-center",
                                                                        children: humanTimeArticle(article.modified, "")
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("h3", {
                                                                        className: "tw-mt-3 tw-text-lg md:tw-text-xl lg:tw-text-2xl tw-leading-8 tw-font-semibold tw-text-center tw-line-clamp-2",
                                                                        dangerouslySetInnerHTML: {
                                                                            __html: article.title.rendered
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("h4", {
                                                                        className: "tw-mt-2 tw-line-clamp-2 tw-text-base tw-italic",
                                                                        dangerouslySetInnerHTML: {
                                                                            __html: article.yoast_head_json.description || ""
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs(Link, {
                                                                        url: {
                                                                            pathname: PagePath.ArticleMobilePage,
                                                                            query: {
                                                                                id: article.slug
                                                                            }
                                                                        },
                                                                        className: "!tw-underline tw-inline-block tw-mt-1",
                                                                        children: [
                                                                            "Xem th\xeam ",
                                                                            ">"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            }, "article-" + article.id);
                                        }),
                                        pagination && /*#__PURE__*/ _jsx("div", {
                                            className: "tw-flex tw-mt-5 tw-justify-end",
                                            children: /*#__PURE__*/ _jsx(Pagination, {
                                                page: pagination.page || 0,
                                                count: (pagination === null || pagination === void 0 ? void 0 : pagination.total_page) || 0,
                                                onPageChange: onPageChange
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 27590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F7": function() { return /* binding */ useFetchCategoryProducts; },
/* harmony export */   "i7": function() { return /* binding */ useFetchPartnersForBanner; },
/* harmony export */   "jR": function() { return /* binding */ useFetchNewsQuery; },
/* harmony export */   "vh": function() { return /* binding */ useFetchFlashSale; }
/* harmony export */ });
/* unused harmony exports fetchMasterData, fetchMasterDataByKey, fetchBanners, fetchPartners, fetchNews, fetchCategoryProducts, fetchFlashSale */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var _layouts_shared__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7806);
/* harmony import */ var _libs_axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80787);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88767);





var fetchMasterData = function() {
    return axios.get("/api/v1/masterdata/list");
};
var fetchMasterDataByKey = function(key) {
    return axios.get("/api/v1/masterdata/".concat(key));
};
var fetchBanners = function() {
    return axios.get("/api/v1/banner", {
        headers: {
            "Content-Type": "application/json; charset=utf-8"
        }
    });
};
var fetchPartners = function() {
    return _libs_axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get("/api/v1/partner/banners");
};
var fetchNews = function(params) {
    return _libs_axios__WEBPACK_IMPORTED_MODULE_1__/* .instanceNews.get */ .iR.get("/wp-json/wp/v2/posts", {
        params: params
    });
};
var fetchCategoryProducts = function(code) {
    return _libs_axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get("/api/v1/products/category/".concat(code, "/list"));
};
var fetchFlashSale = function() {
    return _libs_axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get("/api/v1/products/flash-sale");
};
var useFetchNewsQuery = function(payload, options) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)([
        _layouts_shared__WEBPACK_IMPORTED_MODULE_0__/* .QueryKey.News */ .S8.News,
        payload
    ], function(param) {
        var queryKey = param.queryKey;
        var _queryKey = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(queryKey, 2), params = _queryKey[1];
        return fetchNews(params);
    }, options);
};
var useFetchCategoryProducts = function(code, options) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)([
        _layouts_shared__WEBPACK_IMPORTED_MODULE_0__/* .QueryKey.ProductCategory */ .S8.ProductCategory,
        code
    ], function() {
        return fetchCategoryProducts(code);
    }, options);
};
var useFetchFlashSale = function(options) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)([
        _layouts_shared__WEBPACK_IMPORTED_MODULE_0__/* .QueryKey.FlashSale */ .S8.FlashSale
    ], function() {
        return fetchFlashSale();
    }, options);
};
var useFetchPartnersForBanner = function(options) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)([
        _layouts_shared__WEBPACK_IMPORTED_MODULE_0__/* .QueryKey.PartnersForBanner */ .S8.PartnersForBanner
    ], function() {
        return fetchPartners();
    }, options);
};


/***/ })

}]);